define(function(require, exports, module) {
    'use strict';

    var base = require('base');

    module.name = 'channel-selector';

    module.exports = base.createModule(module.name, [])
        .directive(require('./channel-selector'));
});



/*****************
 ** WEBPACK FOOTER
 ** ./scripts/components/channel-selector/scripts/main.js
 ** module id = 6
 ** module chunks = 0
 **/